import { resolveDojoOsNavItems } from "@/coquille-bridge";
import { karateAppConfig } from "@/config/karateAppConfig.js";
export {
  getAdminNavGroups,
  getAdminMobileNavItems,
  findAdminNavGroupForPath,
  KARATE_ADMIN_GROUP_META,
} from "@/config/karateAdminNavGroups.js";
import { getAdminSidebarItems as getGroupedAdminSidebarItems } from "@/config/karateAdminNavGroups.js";
import {
  getManagerNavGroups,
  getManagerSidebarItems as getGroupedManagerSidebarItems,
  getManagerMobileNavItems,
  findManagerNavGroupForPath,
  getAssistantNavGroups,
  getAssistantSidebarItems as getGroupedAssistantSidebarItems,
  getAssistantMobileNavItems,
  findAssistantNavGroupForPath,
  getPlayerTabItems as getGroupedPlayerTabItems,
  getParentNavItems as getGroupedParentNavItems,
  MANAGER_GROUP_META,
  ASSISTANT_GROUP_META,
  PLAYER_NAV_META,
  PARENT_NAV_META,
} from "@/config/karateRoleNavGroups.js";

export {
  getManagerNavGroups,
  getManagerMobileNavItems,
  findManagerNavGroupForPath,
  getAssistantNavGroups,
  getAssistantMobileNavItems,
  findAssistantNavGroupForPath,
  MANAGER_GROUP_META,
  ASSISTANT_GROUP_META,
  PLAYER_NAV_META,
  PARENT_NAV_META,
};

/**
 * @param {'public'|'admin'|'sensei'|'student'|'parent'|'assistant'} groupId
 * @param {'fr'|'en'} locale
 */
export function resolveKarateNavItems(groupId, locale = "fr") {
  return resolveDojoOsNavItems(karateAppConfig, groupId, locale);
}

/** Items sidebar admin (aplatis depuis groupes BT-025). */
export function getAdminSidebarItems(locale) {
  return getGroupedAdminSidebarItems(locale);
}

/** Items sidebar Sensei / gestionnaire (aplatis depuis groupes BT-026). */
export function getManagerSidebarItems(locale) {
  return getGroupedManagerSidebarItems(locale);
}

/** Onglets étudiant (BT-026). */
export function getPlayerTabItems(locale) {
  return getGroupedPlayerTabItems(locale);
}

/** Nav publique (header) */
export function getPublicNavItems(locale) {
  return resolveKarateNavItems("public", locale);
}

/** Nav espace parent (BT-026). */
export function getParentNavItems(locale) {
  return getGroupedParentNavItems(locale);
}

/** Nav espace Sempai / assistant (aplatis depuis groupes BT-026). */
export function getAssistantSidebarItems(locale) {
  return getGroupedAssistantSidebarItems(locale);
}

export { karateAppConfig };
